import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App'
import { initAnalytics } from './shared/analytics'
import { initSentry } from './shared/observability'
import { ErrorBoundary } from './shared/ui/ErrorBoundary'
import './styles/index.css'

// LGPD Block E — readiness wiring. BOTH are no-ops by default: GA needs
// VITE_GA_ENABLED + measurement id + analytics consent; Sentry needs
// VITE_SENTRY_ENABLED + DSN (+ consent by default). Neither loads any script or
// SDK unless explicitly enabled, so this is inert in the default build.
initAnalytics()
void initSentry()

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root container #root not found in index.html')
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
